module.exports = __webpack_public_path__ + "static/media/info-popup.521335f5.png";